export const iconFontAwesomeConstructionPencil = (
	<i className="fa-solid fa-pencil"></i>
);
